import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  company: {
    logo: string;
    label: string;
  };
  coverageDescriptions: Array<string>;
  label: string;
  price: {
    formattedValue: string;
  };
  shortDescription: string;
  dataTestId?: string;
};

const FormatedClause = ({ clause }) => {
  const clauseParts = clause.split(':');

  if (clauseParts && clauseParts.length === 2) {
    return (
      <span>
        <span className="font-bold">{clauseParts[0]} :</span>
        {clauseParts[1]}
      </span>
    );
  }

  return <span>{clause}</span>;
};

export const InsuranceBody = ({
  company,
  coverageDescriptions,
  label,
  shortDescription,
  dataTestId = '',
}: Props) => (
  <div className="p-20 sm:flex" data-testid={dataTestId}>
    <div className="text-black md:pe-20">
      <h3 className="mb-20 font-bold text-sienna">{label}</h3>
      <p className="mb-20 text-16 font-bold">{shortDescription}</p>
      <div className="gap-20 md:flex">
        {company.logo && (
          <div className="mb-15 border-1 border-pearl px-80 py-30 md:mb-0">
            {company ? <img alt={company.label} src={company.logo} /> : null}
          </div>
        )}
        <ul>
          {coverageDescriptions.map((clause) => (
            <li className="mb-10 text-14 leading-tight" key={clause}>
              <Icon className="me-5 text-blueWave" name={ICONS.CHECK} width="1em" />
              <FormatedClause clause={clause} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);
